import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { IRole } from 'app/shared/Domains/role';
import { AuthService } from 'common/services/auth.service';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: "app-training-session-attd",
    host: { "(window:keyup)": "hotkeys($event)" },
    templateUrl: "./training-session-attd.component.html",
    styleUrls: ["./training-session-attd.component.css"],
})
export class TrainingSessionAttdComponent implements OnInit {
    @Input() sessionId: any;
    @Input() presentClicked: any;
    @Input() rescheduleClicked: any;
    @Output() closeTrainingSessionsDialog = new EventEmitter<any>();

    role: IRole;
    user: IUser;
    trainingSessionsDialog: boolean=true;
    reschedule: boolean = false;
    loading: boolean;
    memberPerformanceArray: any[];
    memberPerformance: any;
    excerciseOptions: any[];
    selectedexcerciseOptions: any;
    selectedDate: any;
    constructor(
        private LanguageService: LanguageService,
        private messageService: MessageService,
        private appServiceManager: AppServiceManager,
    ) {
    }
    ngOnInit(): void {
        this.user = AuthService.getLoggedInUser();
        this.role = AuthService.getLoggedInRole();
        this.selectedDate=new Date();
        this.trainingSessionsDialog=true;
        this.getMemberPerformance();
        this.getExcerciseOptions();



    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("TrainingSessionAttdComponent", label);
      }
    getMemberPerformance(){
        this.memberPerformanceArray = [];
        this.appServiceManager
        .get(
            `branches/${this.user.branch}/training-attendances/reports/member-performance`
        )
        .subscribe(
            (res) => {
                if (res.length > 0) {
                    res.forEach((element) => {
                        this.memberPerformanceArray.push({ name1: element.name, code1: element.name });
                    });
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "No Record Found",
                    });
                }
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );

    }
    getExcerciseOptions(){
        this.excerciseOptions = [];
        this.appServiceManager
        .get(
            `branches/${this.user.branch}/training-attendances/actions/exercise-options`
        )
        .subscribe(
            (res) => {
                if (res.length > 0) {
                    res.forEach((element) => {
                        this.excerciseOptions.push({ name2: element.name, code2: element.name });
                    });
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "No Record Found",
                    });
                }
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );

    }

    markPresent(){
        const url = `branches/${this.user.branch}/training-sessions/${this.sessionId}/actions/mark-present`;
        const body = { exerciseOptions: this.selectedexcerciseOptions, memberPerformance: this.memberPerformance , status: "ATTENDED" };
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            console.log('Attendance Marked', res);
            this.trainingSessionsDialog = false;
            this.hideModal();
        },
            (error) => {
                console.error('Attendance failed', error);
            }
        );
    }
    rescheduleSession(){
        const url = `branches/${this.user.branch}/training-sessions/${this.sessionId}/actions/reschedule`;
        const body = {  date: this.selectedDate };
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            console.log('Date changed', res);
            this.trainingSessionsDialog = false;
            this.reschedule=false;
            this.hideModal();
        },
            (error) => {
                console.error('Date changed failed', error);
            }
        );
    }

    hideModal(){
        this.trainingSessionsDialog=false;
        this.closeTrainingSessionsDialog.emit();
    }

    onCheckboxChange(){
        this.reschedule = true;
    }


}
